<script lang="ts" module>
  import { ICON } from "./icon"

  export { ICON }
</script>

<script lang="ts">
  import type { HTMLAttributes } from "svelte/elements"
  import type { TransitionConfig } from "svelte/transition"

  let {
    type,
    size = 20, // TODO: use `rem` instead of `px`
    transition,
    ...props
  }: {
    type: ICON
    size?: number
    transition?: (node: Element) => TransitionConfig
  } & HTMLAttributes<SVGElement> = $props()
</script>

{#await import(`./icons/${type}.svg?icon`) then icon}
  <icon.default {...props} style={`width: ${size}px; height: ${size}px`} {transition} />
{/await}
